<template>
  <th :class="{ 'fitwidth': fitWidth }">
    <template v-if="header">
      <div class="clickable d-flex align-center ga-2" @click="sortTable">
        <span class="header heading-xs-bold">{{ header }}</span>
        <template v-if="sortable">
          <app-material-icon
            v-if="sorting.name === columnName && sorting.order === 'ASC'"
            name="arrow_downward"
          />
          <app-material-icon
            v-else-if="sorting.name === columnName && sorting.order === 'DESC'"
            name="arrow_upward"
          />
          <app-material-icon
            v-else
            name="mobiledata_arrows"
            color="icon-secondary"
          />
        </template>
      </div>
    </template>
  </th>
</template>

<script>
export default {
  name: 'ProjectsTableHeader',
  props: {
    columnName: {
      type: String,
      required: true,
    },
    header: {
      type: String,
      required: false,
    },
    fitWidth: {
      type: Boolean,
      default: () => true,
    },
    sortable: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      sorting: {
        name: '',
        order: '',
      },
    }
  },
  methods: {
    sortTable () {
      if (!this.sortable) return
      this.sorting = {
        name: this.columnName,
        order: this.sorting.order === 'ASC' ? 'DESC' : 'ASC',
      }
      this.$emit('sort', this.sorting)
    },
  },
}
</script>

<style scoped lang="scss">
@import "@/scss/border-tokens";

th {
  border-bottom: get-border();
  text-align: left;
  padding: 14px 12px;

  @media (max-width: 1600px) {
    padding-left: 14px;
    padding-right: 14px;
  }
}

.header {
  text-transform: capitalize;
  color: rgb(var(--v-theme-text-primary));
}
</style>
